import { parseHealthResponse, type HealthResponse } from '@saldo/contracts';

/**
 * Fetch and validate `/health`.
 *
 * The body is validated with the same schema the API serializes its response with,
 * so a wire change on one side fails on the other instead of being rendered.
 */
export async function fetchHealth(signal?: AbortSignal): Promise<HealthResponse> {
  const response = await fetch('/health', {
    headers: { accept: 'application/json' },
    signal,
  });
  if (!response.ok) {
    throw new Error(`health request failed with status ${response.status}`);
  }
  return parseHealthResponse(await response.json());
}
